import { Map as ImMap } from 'immutable';

import { createDialog } from 'app-components/flux/root-ui/rootUiActions';
import { mkRootUiData } from 'app-components/flux/root-ui/rootUiTypes';
import store from 'app-components/utils/redux-store';

import type { ConfirmationDialogProps } from './types';
import { DIALOG_TYPE as CONFIRMATION_DIALOG_TYPE, mkConfirmationDialogProps } from './types';

export type ShowConfirmationDialogOptions = ConfirmationDialogProps & {
  /** The dialog id. A dialog with the same id that is already showing blocks this one. */
  id?: string;
};

const showConfirmationDialog = (props: ShowConfirmationDialogOptions): void => {
  store?.dispatch(
    createDialog(
      mkRootUiData({
        id: props.id || 'delete-project',
        type: CONFIRMATION_DIALOG_TYPE,
        props: ImMap(mkConfirmationDialogProps(props)),
      }),
    ),
  );
};
export default showConfirmationDialog;
